import uiRouter from '@uirouter/angularjs';
import angular from 'angular';
import { OrdersModalsRequestControllerModule } from './controllers/OrdersModalsRequestController';

export const OrdersModalsRequestView = angular
  .module('acme.view.application.orders.modals.request', [
    uiRouter,
    'ui.bootstrap',
    OrdersModalsRequestControllerModule,
  ])
  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const ordersModalsRequest = {
      name: 'application.request',
      url: '/orders/modals/request',
      views: {
        main: {
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/orders/modals/request/request.tpl.html',
        },
      },
      data: {
        pageTitle: 'Orders Request',
        enablePreferences: true,
      },
    };

    $stateProvider.state(ordersModalsRequest);
  }).name;
